import Header from "../Section/Header";
import Footer from "../Section/Footer";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, Clock, IndianRupee } from "lucide-react";
import {
  server_post_data,
  get_marriagee_data,
} from "../../ServiceConnection/serviceconnection";
import { CustomAlert } from "../../CommonJquery/CustomAlert";
import { formatDOB } from "../../CommonJquery/CommonJquery";
import { useParams } from "react-router-dom";

export default function MyPayments() {
  const navigate = useNavigate();
  const { id } = useParams();
  const astrologer = id;
  console.log(astrologer);
  const [astrodata, setAstrodata] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const fetchAstroData = async () => {
    const formData = new FormData();
    setIsLoading(true);
    await server_post_data(get_marriagee_data, formData)
      .then((Response) => {
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          let final_data = JSON.parse(data[1]);
          setAstrodata(final_data[0]["astrologer_type_list"]);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchAstroData();
  }, []);
  const handleNavigateTo = (item) => {
    //error
  };
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-[1250px] mx-auto py-10 px-4">
          {/* Heading */}
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4">
              💰 My Payments
            </h2>
            <p className="text-lg text-purple-300 mb-6">
              Track all your payments and stay informed about your recent
              transactions
            </p>
          </div>

          {/* Forum Section */}
          <div className="mt-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {astrodata.map((item, index) => (
                <div
                  key={index}
                  className="rounded-xl bg-slate-800/60 border border-yellow-500/20  transition-all duration-300 hover:scale-[1.02] backdrop-blur-lg p-4 flex flex-col justify-between"
                >
                  <div>
                    <h3 className="text-lg font-semibold text-[var(--light-pink-color)] mb-2">
                      Transaction ID: {item.trans_id}
                    </h3>

                    {/* Updated with Lucide Icons */}
                    <p className="text-sm text-gray-300 flex items-center gap-2 flex-wrap">
                      <span className="flex items-center gap-1 ">
                        <IndianRupee
                          ock
                          className="w-4 h-4 text-[var(--light-pink-color)] "
                        />{" "}
                        {item.payment_amount}
                      </span>
                      <span className="flex items-center gap-1">
                        <CalendarDays className="w-4 h-4 text-[var(--light-pink-color)]" />{" "}
                        {item?.for_call_date
                          ? formatDOB(item.for_call_date)
                          : "NA"}
                      </span>

                      <span className="flex items-center gap-1">
                        <Clock className="w-4 h-4 text-[var(--light-pink-color)]" />{" "}
                        {item.for_call_time}
                      </span>
                    </p>
                  </div>

                  {/* <div className="flex justify-end mt-3">
                    <button
                      className="cursor-pointer items-center gap-1 border border-purple-200 bg-purple-50 text-[var(--primary-color)] px-[25px] py-1.5 rounded-lg font-medium text-[15px] hover:bg-[--primary-hover-dark] hover:text-white transition"
                      onClick={() => handleNavigateTo(item)}
                    >
                      View
                    </button>
                  </div> */}
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
